<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-6">Zmień hasło</h1>
      <v-form @submit.prevent autocomplete="off">
        <validation-observer ref="observer" v-slot="{}">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="passwordRules"
            name="Nowe hasło"
          >
            <v-text-field
              v-model="password"
              :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              label="Hasło"
              placeholder="Hasło"
              :error-messages="errors"
              outlined
              persistent-placeholder
              background-color="white"
              class="mb-2"
              autocomplete="new-password"
            />
          </ValidationProvider>

          <ValidationProvider
            name="Powtórz hasło"
            rules="required"
            v-slot="{ failed }"
          >
            <v-text-field
              v-model="repeatPassword"
              :append-icon="e2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e2 = !e2)"
              :type="e2 ? 'password' : 'text'"
              label="Powtórz hasło"
              placeholder="Hasło"
              :error="failed"
              outlined
              persistent-placeholder
              background-color="white"
              autocomplete="new-password"
            />
          </ValidationProvider>
          <LoginAlerts
            :show="message.show"
            :type="message.color"
            :msg="message.msg"
            @close="message.closeAction"
            dismissible
          />
          <div class="actions">
            <div class="actions_links">
              <LibBtnSimple
                color="primary"
                text="Wróć do logowania"
                rounded
                underline
                title="Wróć do logowania"
                :to="{ name: 'Login' }"
                class="mr-2"
              />

              <v-btn
                @click="resetPassword"
                type="submit"
                class="mt-1"
                title="Zmień"
                large
                depressed
                rounded
                color="primary"
              >
                Zapisz hasło
              </v-btn>
            </div>
          </div>
        </validation-observer>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import LoginAlerts from "../components/LoginAlerts.vue";

import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
setInteractionMode("lazy");
extend("required", required);
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Hasła muszą być identyczne"
});

export default {
  name: "resetpaswd",
  components: {
    ValidationObserver,
    ValidationProvider,
    LibBtnSimple,
    LoginAlerts
  },
  props: {
    h: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      password: "",
      repeatPassword: "",
      e1: true,
      e2: true,
      error: null,
      passwordRulesBase: {
        required: true,
        password: { target: "@Powtórz hasło" }
      },
      message: {
        show: false,
        color: "error",
        msg: "",
        timeout: 0,
        closeAction: () => {}
      },
      loading: false
    };
  },
  computed: {
    passwordRules() {
      const param = this.$store.getters["conf/getConfigurationParam"](
        "password.strength"
      );
      if (param) {
        extend("regex", {
          ...regex,
          message: param.description
        });
        return Object.assign({}, this.passwordRulesBase, {
          regex: param.value
        });
      }
      return this.passwordRulesBase;
    }
  },

  methods: {
    resetPassword() {
      this.$refs.observer.validate().then((result) => {
        this.loading = true;
        if (result) {
          axios
            .post(`${process.env.VUE_APP_AUTH_REST_URL}/password/change`, {
              hash: this.h,
              password: this.password
            })
            .then(({ data }) => {
              if (data.success) {
                this.message.msg = "Hasło zostało zmienione.";
                this.message.color = "success";
                this.message.show = true;
                this.message.closeAction = () => {
                  window.location.replace("/");
                };
              } else {
                this.message.msg = data.errorMessage;
                this.message.color = "error";
                this.message.show = true;
                this.message.closeAction = () => {
                  this.message.show = false;
                };
              }
              this.loading = false;
            })
            .catch(() => {
              this.message.msg = "Błąd zmiany hasła. Spróbuj później.";
              this.message.color = "error";
              this.message.show = true;
              this.message.closeAction = () => {
                this.message.show = false;
              };
              this.loading = false;
            });
        }
      });
    }
  },
  metaInfo: {
    title: "Zmiana hasła"
  }
};
</script>
